//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'barMul',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    legend: Array,
    subtext: String,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      var series = [];

      for (var j in this.legend) {
        var list = this.legend[j];
        var obj = {
          name: list,
          type: 'bar',
          data: [],
          barMaxMWidth: '30'
        };

        for (var i in this.xAxis) {
          obj.data.push(this.value[i][j]);
        }

        series.push(obj);
      }

      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'left',
          textStyle: {
            fontSize: 14,
            marginTop: '-8px'
          }
        },
        "color": ["#2d8cf0", "#0586a1", "#5d42a5"],
        legend: {
          data: this.legend,
          textStyle: {
            color: '#000'
          }
        },
        grid: {// left: '4%',
          // right: '4%',
          // bottom: '4%',
          // top:'4%',
          // containLabel: true
        },
        tooltip: {// trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            show: true,
            color: '#0a98bc'
          },
          // 刻度标签
          splitLine: {
            //// 分隔线
            show: false,
            lineStyle: {
              color: "#8494a3"
            }
          },
          //// 坐标轴线
          axisLine: {
            show: true,
            color: '#8494a3',
            lineStyle: {
              color: '#8494a3'
            }
          },
          data: this.xAxis
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            //坐标轴线
            lineStyle: {
              color: "#2d8cf0"
            }
          },
          splitLine: {
            //分隔线
            show: false,
            lineStyle: {
              color: "#2d8cf0"
            }
          },
          axisLabel: {
            // 刻度标签
            color: "#2d8cf0",
            lineStyle: {
              fontSize: '12'
            }
          }
        },
        series: series
      };
      return this.option;
    },
    init: function init() {
      var _this = this;

      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      setTimeout(function () {
        _this.resize();
      });
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};